import Http from '../http'

export default {

  index(filters) {
    return Http.get(`/categories`, {params: {...filters}})
  },

  indexByModel({model, model_id}) {
    return Http.get(`${model}/${model_id}/categories`)
  },

  create(category){
    return Http.post(`/categories`, {
      category: {
      ...category,
      }
    })
  },

  update(category){
    return Http.put(`/categories/${category.id}`, {
      category: {
        ...category,
      },
    });
  },

  show(id) {
    return Http.get(`/categories/${id}`);
  },

  delete(id){
    return Http.delete(`/categories/${id}`)
  }

}
